<template>
  <div class="encourage">
    <div class="o-filters">
      <div class="o-filters__container h-remove-child-margin">
        <tabs v-model="selectedTabId" :tabs="tabs" />
        <filters v-if="filters" v-model="filters" :showGlobalCheckboxes="selectedTabId === 0" />
      </div>
    </div>

    <div class="encourage__map" :class="{ 'encourage__map--hidden': selectedTabId !== 0 }">
      <div class="encourage__map-inner">
        <map-page :gatherings="filteredGatheringsBusinesses.gatherings" :businesses="filteredGatheringsBusinesses.businesses" />
      </div>
    </div>

    <gathering-list-page v-show="selectedTabId === 1" :gatherings="filteredGatheringsBusinesses.gatherings" />
    <business-list-page v-show="selectedTabId === 2" :businesses="filteredGatheringsBusinesses.businesses" />
  </div>
</template>

<script>
import MobileService from '@/services/mobile'
import LoaderService from '@/services/loader'
import FiltersService from '@/services/filters'

import Tabs from '@/components/ui/tabs'
import Filters from '@/components/pages/encourage/components/filters'
import MapPage from '@/components/pages/encourage/components/map'
import GatheringListPage from '@/components/pages/encourage/components/gathering-list'
import BusinessListPage from '@/components/pages/encourage/components/business-list'

export default {
  components: {
    Tabs,
    Filters,
    MapPage,
    GatheringListPage,
    BusinessListPage
  },
  data() {
    return {
      gatherings: [],
      businesses: [],
      selectedTabId: 0,
      tabs: [
        { id: 0, label: this.$t('tab-map'), icon: 'pin' },
        { id: 1, label: this.$t('tab-list-gatherings'), icon: 'list' },
        { id: 2, label: this.$t('tab-list-businesses'), icon: 'list' }
      ],
      filters: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    const gatherings = await MobileService.getAllGatherings()
    const businesses = await MobileService.getAllBusinesses()
    const filters = FiltersService.initialiseFilters(gatherings.rassemblements, businesses.users)

    next(vm => {
      vm.gatherings = gatherings.rassemblements
      vm.businesses = businesses.users
      vm.filters = filters
      LoaderService.hideLoader()
    })
  },
  computed: {
    filteredGatheringsBusinesses: function() {
      let filteredGatherings = this.gatherings
      let filteredBusinesses = this.businesses

      if (this.filters) {
        const { gatheringIds, businessIds, hasFilterApplied, showGatherings, showBusinesses } = FiltersService.getFilteredGatheringsBusinesses(this.filters)

        if (hasFilterApplied) {
          filteredGatherings = filteredGatherings.filter(x => gatheringIds.has(x.id))
          filteredBusinesses = filteredBusinesses.filter(x => businessIds.has(x.id))
        }

        if (this.filters.name !== '') {
          filteredGatherings = filteredGatherings.filter(
            x => x.name.toLowerCase().includes(this.filters.name) || x.businessesData.filter(y => y.name.toLowerCase().includes(this.filters.name)).length > 0
          )
          filteredBusinesses = filteredBusinesses.filter(x => x.name.toLowerCase().includes(this.filters.name))
        }

        return {
          gatherings: this.selectedTabId !== 0 || showGatherings ? filteredGatherings : [],
          businesses: this.selectedTabId !== 0 || showBusinesses ? filteredBusinesses : []
        }
      }
      return { gatherings: this.gatherings, businesses: this.businesses }
    }
  }
}
</script>

<style lang="scss">
.encourage {
  &__map {
    height: auto;
    overflow: hidden;

    &-inner {
      position: relative;
      height: 480px;
      margin-top: 24px;
    }

    &--hidden {
      height: 0;
    }
  }
}

.empty-list {
  text-align: center;
  margin: auto;
}

.magIcon {
  background: url(~@/assets/images/mag.svg) no-repeat center center;
  background-size: contain;
  height: 200px;
  display: block;
}

/*Pour grille une colonne*/
.h-remove-child-padding-top {
  > :first-child {
    padding-top: 0;
  }
}

@media (min-width: 568px) {
  /*Pour grille deux colonne*/
  .h-remove-child-padding-top {
    > :nth-child(-n + 2) {
      padding-top: 0;
    }
  }
}

@media (min-width: 768px) {
  .encourage {
    &__map {
      &-inner {
        height: 768px;
      }
    }
  }

  .magIcon {
    margin-top: spacing('bold');
    height: 350px;
  }
}

@media (min-width: 992px) {
  /*Pour grille trois colonne*/
  .h-remove-child-padding-top {
    > :nth-child(-n + 3) {
      padding-top: 0;
    }
  }
}
</style>
